import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Big } from 'foundations-components/transitional/components/Big';
import { Small } from 'foundations-components/transitional/components/Small';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MeetingInfo({
  meetingTopic,
  meetingID
}) {
  return /*#__PURE__*/_jsx(Alert, {
    type: "info",
    children: /*#__PURE__*/_jsxs(View, {
      padding: "200",
      as: "div",
      children: [/*#__PURE__*/_jsx(InlineLabel, {
        label: /*#__PURE__*/_jsx(Big, {
          weight: "bold",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "meetInfo.topic"
          })
        }),
        children: /*#__PURE__*/_jsx(Small, {
          children: meetingTopic
        })
      }), /*#__PURE__*/_jsx(InlineLabel, {
        label: /*#__PURE__*/_jsx(Big, {
          weight: "bold",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "meetInfo.id"
          })
        }),
        children: /*#__PURE__*/_jsx(Small, {
          children: meetingID
        })
      })]
    })
  });
}
export default MeetingInfo;